import React from 'react';
import { AuthServiceInterface } from '../services/AuthService';
import { Button, Message } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import Page from '../components/Page';

interface EmailVerificationRequiredPageProps {
  auth?: AuthServiceInterface;
  firstLogin?: boolean;
}

interface EmailVerificationRequiredPageState {
  disableButton: boolean;
}

@inject('auth')
@observer
export default class EmailVerificationRequiredPage extends React.Component<
  EmailVerificationRequiredPageProps
  , EmailVerificationRequiredPageState
> {

  state: EmailVerificationRequiredPageState = {
    disableButton: false,
  };

  async sendVerificationEmail(): Promise<void> {
    this.setState({ disableButton: true });
    if (this.props.auth) {
      await this.props.auth.sendVerificationEmail();
    }
  }

  render(): React.ReactNode {
    return (
 <Page
    pageTitle='Email Verification Required'
  >
    <Message warning>
      {/* <Message.Header>Email Verification Required</Message.Header> */}
      <p style={{  textDecoration: 'underline', margin: '0' }}>
        <span style={{ color: 'black', fontSize: '1.2em' }}>We have sent a email verification to <strong>{this.props.auth?.user?.email}</strong></span>
      </p>
      <p style={{ color: 'red', fontWeight: 900, margin: '0', fontSize: '1.4em' }}>
        If you don't see the email, please check your spam or junk folders
      </p>
      <p style={{ margin: '0', fontSize: '1.4em' }}>
        Open the email and click the <span style={{ color: 'blue' }}>blue link</span> to verify your email address
      </p>
    </Message>
    {
      this.props.firstLogin
        ? ''
        :
        <React.Fragment>
          <p>
            If you would like us to resend the confirmation email, please click the button below.
          </p>
          <Button primary disabled={this.state.disableButton} onClick={(): Promise<void> => this.sendVerificationEmail()}>
            {
              this.state.disableButton ? 'Email Sent' : 'Re-send Verification Email'
            }
          </Button>
        </React.Fragment>
    }
  </Page>
    );
  }
}